/* eslint-disable */
export const protobufPackage = 'com.celertech.positionmanager.api.enums.side';

export enum Side {
    BUY = 1,
    SELL = 2,
    UNRECOGNIZED = -1
}
